import React, { useEffect, useState } from "react";
import AppRoutes from "./routes";
import Toast from "./components/toastMessage/Toast";
import GlobalContext from "./components/Context/GlobalContext";
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from "./store";
import { fetchFeatureFlags } from "./functions/appconfig";
import { useDispatch } from "react-redux";
import { setFeatureFlags } from "./store/slices/featureFlags";

const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    // Define an asynchronous function to fetch feature flags
    const fetchFlags = async () => {
      try {
        // Fetch the feature flags from the API or service
        const flags = await fetchFeatureFlags();
  
        // Dispatch the fetched flags to update the state using Redux
        dispatch(setFeatureFlags(flags));
      } catch (error) {
        // Log an error if fetching feature flags fails
        console.error("Error fetching feature flags:", error);
      }
    };
  
    // Call the fetchFlags function when the component mounts
    fetchFlags();
  }, []); // Empty dependency array ensures this effect runs only once on mount
  return (
    <PersistGate loading={null} persistor={persistor}>
      <div className="min-h-screen bg-gray-100 overflow-hidden">
        <GlobalContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
          <AppRoutes />
          <Toast />
        </GlobalContext.Provider>
      </div>
    </PersistGate >
  );
};

export default App;
